export default __webpack_public_path__ + "static/media/sTitle@3x.5aeb85b4.png";